import { api } from "@/lib/api";

export async function createAlert({
  level,
  address,
  location,
  client_name,
  notes,
  reminder_delay_minutes,
}) {
  const { data } = await api.post("/alerts", {
    level,
    address: address || null,
    location: location || null,
    client_name: client_name || null,
    notes: notes || null,
    reminder_delay_minutes: reminder_delay_minutes ?? null,
  });
  return data;
}

export async function listAlerts({ status = "active", level = "all", mine = false, limit = 50, skip = 0 } = {}) {
  const { data } = await api.get("/alerts", {
    params: { status, level, mine, limit, skip },
  });
  return data;
}

export async function getAlert(id) {
  const { data } = await api.get(`/alerts/${id}`);
  return data;
}

export async function closeAlert(id, { reason = "manual", notes = null } = {}) {
  const { data } = await api.post(`/alerts/${id}/close`, { reason, notes });
  return data;
}

export async function takeCharge(id) {
  const { data } = await api.post(`/alerts/${id}/take-charge`);
  return data;
}

export async function markPoliceCalled(id) {
  const { data } = await api.post(`/alerts/${id}/police-called`);
  return data;
}

export async function getStats() {
  const { data } = await api.get("/alerts/stats");
  return data;
}

export async function reverseGeocode(lat, lng) {
  const { data } = await api.post("/geocode/reverse", { lat, lng });
  return data;
}
